module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/mojo-logo-769f74e09a27b7326d59b59000bf48a0.svg";